import {FormSection} from '@/components/commons/form-section/FormSection'
import {useTranslation} from '@/translations/i18n'
import {Controller, useFormContext} from 'react-hook-form'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {InputText} from '@/components/commons/input-text/InputText'
import {CompanyInfoFormValidationSchema} from '@/features/company-info/types'

export const BankInfoSection = () => {
    const {t} = useTranslation()
    const {
        control,
        formState: {errors}
    } = useFormContext<CompanyInfoFormValidationSchema>()

    return (
        <FormSection title={t('company_info:form:bank_info_section_title')}>
            <Grid columns={2} gap={4}>
                <GridItem>
                    <Controller
                        control={control}
                        name="bankName"
                        render={({field}) => (
                            <InputText
                                label={t('company_info:form:bank_name_label')}
                                type="text"
                                errorMessage={errors.bankName?.message}
                                touched={!!errors.bankName}
                                {...field}
                            />
                        )}
                    />
                </GridItem>
                <GridItem>
                    <Controller
                        control={control}
                        name="bankBranch"
                        render={({field}) => (
                            <InputText
                                label={t('company_info:form:bank_branch_label')}
                                type="text"
                                errorMessage={errors.bankBranch?.message}
                                touched={!!errors.bankBranch}
                                {...field}
                            />
                        )}
                    />
                </GridItem>
                <GridItem>
                    <Controller
                        control={control}
                        name="iban"
                        render={({field}) => (
                            <InputText
                                label={t('company_info:form:bank_iban_label')}
                                type="text"
                                errorMessage={errors.iban?.message}
                                touched={!!errors.iban}
                                {...field}
                            />
                        )}
                    />
                </GridItem>
                <GridItem>
                    <Controller
                        control={control}
                        name="bic"
                        render={({field}) => (
                            <InputText
                                label={t('company_info:form:bank_swift_bic_label')}
                                type="text"
                                errorMessage={errors.bic?.message}
                                touched={!!errors.bic}
                                {...field}
                            />
                        )}
                    />
                </GridItem>
            </Grid>
        </FormSection>
    )
}
